<div class="flex flex-col justify-start items-stretch h-full m-4 gap-y-6">
  <div class="flex flex-col lg:flex-row md:justify-between items-stretch md:space-x-4 md:space-y-0 space-y-2"
    *ngIf="customer">
    <div class="flex flex-col justify-start items-stretch sm:flex-row sm:justify-start sm:items-start flex-grow w-full">
      <div class="flex flex-col justify-start sm:items-start items-center flex-grow-0 flex-shrink">
        <h1>{{ customer | customerName }}</h1>
        <p>
          <strong>Contact Details:</strong>
          {{ customer | customerContactDetails }}
        </p>
        <p><strong>Address:</strong> {{ customer | customerAddress }}</p>
        <p *ngIf="customer?.business">
          <strong>Vat No:</strong> {{ customer?.vat_number }}
        </p>
        <app-integration-relationship-info [customer]="customer"></app-integration-relationship-info>
      </div>
      <div
        class="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 space-4 md:justify-items-stretch justify-items-center w-full flex-grow sm:px-12"
        *ngIf="customerBalances">
        <app-key-value-pair name="Total Balance" [key]="'Total'"
          [value]="customerBalances.total | hlCurrency | async"></app-key-value-pair>
        <app-key-value-pair name="Invoice" [key]="'Invoice Balance'"
          [value]="customerBalances.invoice | hlCurrency | async"></app-key-value-pair>
        <app-key-value-pair name="Contract" [key]="'Contract Balance'"
          [value]="customerBalances.contract | hlCurrency | async"></app-key-value-pair>
        <app-key-value-pair name="Repairs" [key]="'Repairs'"
          [value]="customerBalances.repairs | hlCurrency | async"></app-key-value-pair>
        <app-key-value-pair name="Sales" [key]="'Sales'"
          [value]="customerBalances.sales | hlCurrency | async"></app-key-value-pair>
      </div>
    </div>
    <div
      class="flex flex-col md:items-start items-center justify-start space-y-2 md:space-y-0 md:flex-row md:justify-center md:space-x-4 md:flex-grow-0 w-full md:w-auto">
      <div class="flex flex-row justify-end items-center md:basis-auto">
        <button class="flex-shrink-0" mat-flat-button [routerLink]="['edit']">
          Edit Customer
        </button>
        <button mat-icon-button color="primary" [mat-menu-trigger-for]="editMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <mat-menu #editMenu>
        <button (click)="editAlertMessage()" mat-menu-item>
          Edit Alert Message
        </button>
        <button (click)="mergeCustomer()" mat-menu-item>
          Merge Customer
        </button>
      </mat-menu>
      <button mat-flat-button class="flex-shrink-0" (click)="newDocket()" color="primary"
        [testId]="testIds.NEW_TRANSACTION_BUTTON">
        New Transaction
      </button>
    </div>
  </div>

  <mat-tab-group class="basis-full">
    <mat-tab label="Previously Hired Items" fxLayout="column">
      <ng-template matTabContent>
        @if(customerId$ | async; as customerId) {
        <app-previously-hired-items [customerId]="customerId"></app-previously-hired-items>
        }
      </ng-template>
    </mat-tab>
    <mat-tab label="Product prices" [testId]="testIds.PRODUCT_PRICES_TAB">
      <ng-template matTabContent>
        @if(customerId$ | async; as customerId) {
        <app-customers-prices-tab [customerId]="customerId"></app-customers-prices-tab>
        }
      </ng-template>
    </mat-tab>
    <mat-tab label="Emails">
      <ng-template matTabContent>
        @if(emailListSource$ | async; as source) {
        <app-email-list [source]="source" [linkToDocket]="true" />
        }
      </ng-template>
    </mat-tab>
    <mat-tab label="Bookings">
      <ng-template matTabContent>
        <booking-list containingComponent="customer" [bookings]="customer?.bookings" [height]="height"></booking-list>
      </ng-template>
    </mat-tab>
    <mat-tab label="Own equipment">
      <ng-template matTabContent>
        <app-customer-equipment [customerId]="customerId$ | async"></app-customer-equipment>
      </ng-template>
    </mat-tab>
    <mat-tab label="Sales">
      <ng-template matTabContent>
        <app-sales-history [customerId]="customerId$ | async"></app-sales-history>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="mt-16">
    <app-comments [type]="'customer'" [id]="customerId$ | async" [comments]="customer?.comments"
      class="mt-16"></app-comments>
  </div>
</div>